import NotesDisplay from './notes-display'
import NotesEdit from './notes-edit'

export default {
  NotesDisplay,
  NotesEdit
}